// extracted by mini-css-extract-plugin
export default {"languageSelectWrapper":"LanguageSelect_languageSelectWrapper__D-aHF","selectedLanguage":"LanguageSelect_selectedLanguage__C12-Y"};